

export default {
  namespaced: true,
  state: {
    filters: []
  },

  getters: {
      filters: (state)  => {
        return state.filters
      }
  },

  mutations: {
    setFilters(state, filters) {
        state.filters = filters;
    },
  },

};
